import { OperatorResponse } from '@/modules/api/openapi/models/OperatorResponse'
import { monitorMessage } from '@/modules/monitoring'

// regional operators do not have thier names in config_operators
export const customOperatorNames: { [k: string]: string } = {
  bird_oakland: 'Bird Oakland',
  grin_guadalajara: 'Grow Guadalajara',
  grin_zapopan: 'Grow Zapopan',
  jump_bike: 'JUMP Bikes',
  lime_oakland: 'Lime Oakland',
  lime_sac: 'Lime Sacramento',
  lime_sf: 'Lime SF',
  lime_wsac: 'Lime West Sacramento',
}

export const getOperatorDisplayName = (operator?: OperatorResponse): string => {
  if (!operator) {
    return 'Unknown Operator'
  }

  if (!operator.name) {
    monitorMessage(`operatorData.ts missing name: ${operator.slug}`)
    return 'Unknown Operator'
  }

  return customOperatorNames[operator.slug] || operator.name
}

export { OperatorLogo } from '@/modules/operator/OperatorLogo'
